<template>
    <div class="warn-dot tooltip  ml1 mr2 relative bg-color-cta relative" @click="toggleTooltip = !toggleTooltip">
    <div class="white" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">?</div>
        <div class="tooltip-bubble absolute p2 drop-shadow op0 flex flex-column justify-center" :class="{tooltipAppear: toggleTooltip == true}">
                <button class="lightbox-close-btn tooltip-close-btn" @click.stop="toggleTooltip = !toggleTooltip">
                  <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
            <p class="color-gray bold" v-html="headline"></p>
            <p class="color-gray relative z2" v-html="paragraph"></p>
        </div>
    </div>
</template>

<script>

export default {
  name: 'Tooltip',
  data() {
    return {
        toggleTooltip: false,
    }
  },
  methods: {
  },
  props: {
    'headline': String,
    'paragraph': String
  }

}
</script>

<style scoped>

</style>